import { Route, Routes } from 'react-router-dom';
import Help from '../../components/help/Help';
import { IRoute } from '../interfaces/IRoute';
import { addLayoutToComponent } from '../utils';
import { UserRoles, stringToUserRolesEnum } from '../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { RootState, getCurrentUser } from '../../store';
import { User } from '../../store/types';

export const HelpRoutes = () => {
    const dispatch = useDispatch();

    const currentUser: User | null = useSelector(
        (state: RootState) => state.auth.currentUser
    );

    useEffect(() => {
        dispatch(getCurrentUser());
    }, []);

    const routes: IRoute[] = [
        {
            path: '/',
            element: addLayoutToComponent(
                <Help />,
                'help',
                currentUser
                    ? stringToUserRolesEnum(currentUser.userRole.key)
                    : UserRoles.unauthenticated
            ),
        },
    ];

    return (
        <Routes>
            {routes.map((value, index) => (
                <Route
                    key={index}
                    path={value.path}
                    element={value.element}
                ></Route>
            ))}
        </Routes>
    );
};
